import React, { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import DataTable, { createTheme } from "react-data-table-component";
import { useTheme } from "../../../context/ThemeContext";
import TableLoader from "../../skeletons/TableLoader";
import { checkPermission } from "../../../helpers/GeneralHelper";
import dateFormat from "dateformat";
import { utcToLocal } from "../../../helpers/DateHelper";
import { getCmsDataTableStyles } from "../../../helpers/DataTableStyles";
import {
  isResumeConverted,
} from "../../../helpers/ResumeToCandidateHelper";

export default function ResumesTable({
  module,
  data,
  loading,
  totalRows,
  page,
  limit,
  fetchData,
  isTrash,
  onRowSelect,
  onCreateCandidate,
  onViewConvertedCandidate,
}) {

  const columns = [
    {
      name: "#",
      selector: (row, index) => <div>{ ((page -1 ) * limit) + index +1 }.</div>,
      width: '100px'
    },
    {
            name: <div title="Name">Name</div>,
            selector: (row) => (
              <div>
                <span>{row.resume_name}</span>
                {isResumeConverted(row) && (
                  <span className="badge resume-converted-badge ms-2">Converted</span>
                )}
              </div>
            ),
            sortable: true,
            width: '200px',
            wrap: true,
            grow: 2, // optional, allows wider columns
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
            }
        },
        {
            name: <div title="Email">Email</div>,
            selector: (row) => row.resume_email ? row.resume_email : '--',
            sortable: true,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div title="Phone">Phone</div>,
            selector: (row) => row.resume_phone ? row.resume_phone : '--',
            sortable: true,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div title="Location">Location</div>,
            selector: (row) => row.resume_location ? row.resume_location : '--',
            sortable: true,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
  name: <div title="Experience">Experience</div>,
  width: '15%',
  selector: (row) => {
    if (!row.experiences) return "--";

    const experienceList = row.experiences.split(" || ").map(exp => exp.trim());

    return (
      <ul style={{ paddingLeft: "18px", margin: 0, textAlign: "left" }}>
        {experienceList.map((exp, idx) => {
          const [title, company, duration, location] = exp.split(" | ").map(s => s.trim());
          return (
            <li key={idx} style={{ marginBottom: "8px" }}>
              <div><strong>{title || "N/A"}</strong></div>
              <div>Company: {company || "N/A"}</div>
              <div>Duration: {duration || "N/A"}</div>
              <div>Location: {location || "N/A"}</div>
            </li>
          );
        })}
      </ul>
    );
  },
  wrap: true,
  style: {
    whiteSpace: "normal",
    wordBreak: "break-word",
    maxWidth: "none",
  },
},


        {
            name: <div title="Skills">Skills</div>,
            selector: (row) => row.resume_skills ? row.resume_skills : '--',
            width: '15%',
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
        {
            name: <div>Creaated At</div>,
            selector: (row) => row.resume_created_at ? utcToLocal(row.resume_created_at) : '--',
            sortable: true,
            style: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                maxWidth: 'none',
            },
            wrap: true,
        },
    // {
    //   name: "Added On",
    //   selector: (row) => utcToLocal(row.onboard_create_time)  
    // },
    // {
    //   name: "Last Edited On",
    //   selector: (row) => utcToLocal(row.onboard_update_time)
    // },
  ];

  if (
    !isTrash &&
    checkPermission("candidates", "add") &&
    (typeof onCreateCandidate === "function" ||
      typeof onViewConvertedCandidate === "function")
  ) {
    columns.push({
      name: "Action",
      width: "150px",
      cell: (row) => {
        if (isResumeConverted(row)) {
          return (
            <button
              type="button"
              className="btn btn-sm btn-outline-success"
              title="View linked candidate"
              onClick={() => onViewConvertedCandidate?.(row)}
            >
              <i className="ri-user-search-line me-1" />
              View candidate
            </button>
          );
        }

        if (typeof onCreateCandidate !== "function") {
          return null;
        }

        return (
          <button
            type="button"
            className="btn btn-sm btn-primary"
            title="Create candidate from this resume"
            onClick={() => onCreateCandidate(row)}
          >
            <i className="ri-user-add-line me-1" />
            Candidate
          </button>
        );
      },
    });
  }

//   if (! isTrash && (checkPermission(module.route, 'edit') || checkPermission(module.route, 'delete'))) {
//     columns.push({
//       name: "Action",
//       right: "true",
//       cell: row => <div className="hstack gap-2 fs-15">
//                     {
//                       row.onboard_is_offboard==0 ? <button type="button" className="btn btn-icon btn-sm btn-info" title="Off Board" onClick={() => openOffboardModal(row)}>
//                       <i className='bx bxs-plane'></i>
//                     </button> : ''
//                     }
//                     {checkPermission(module.route, 'edit') && <button type="button" className="btn btn-icon btn-sm btn-info" title="Edit" onClick={() => openUpdateModal(row)}>
//                       <i className='bx bxs-edit'></i>
//                     </button>}

//                     {checkPermission(module.route, 'delete') && <button type="button" className="btn btn-icon btn-sm btn-danger" title="Delete" onClick={() => openDeleteModal(row)}>
//                       <i className='bx bxs-trash'></i>
//                     </button>}
//                   </div>
//     });
//   }

  if (isTrash) {
    columns.push({
      name: "Deleted At",
      selector: (row) => utcToLocal(row.onboard_delete_time)
    });
  }

  const { theme, toggleTheme } = useTheme();

  const handlePageChange = async (page) => {
    fetchData(limit, page);
  };

  const handleLimitChange = async (newLimit, page) => {
    //if ((newLimit !== 10 && page !== 1) || localStorage.getItem(module.key)) {
      fetchData(newLimit, page);
    //}
  };

  // useEffect(() => {
  //   fetchData(limit, page);
  // }, []);

  createTheme("dark", {
    text: {
      primary: "#a2a3a4",
      secondary: "#2aa198",
    },
    background: {
      default: "#252729",
    },
    context: {
      background: "#cb4b16",
      text: "#a2a3a4",
    },
    divider: {
      default: "#073642",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.08)",
      disabled: "rgba(0,0,0,.12)",
    },
  });

    return (
        <DataTable
            //title={module.title}
            className="clickable cms-data-table"
            //   onRowClicked={(row) => handleView(row)}
            columns={columns}
            data={data}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handleLimitChange}
            onChangePage={handlePageChange}
            progressPending={loading}
            progressComponent={<TableLoader noOfColumn={columns.length} />}
            fixedHeader
            fixedHeaderScrollHeight="75vh"
            highlightOnHover
            paginationPerPage={10}  // default page size
            paginationRowsPerPageOptions={[10, 25, 50, 100, totalRows]} // 👈 added custom options
            theme={`${theme === "light" ? "light" : "dark"}`}
            customStyles={getCmsDataTableStyles(theme)}
            selectableRows
            onSelectedRowsChange={({ selectedRows }) => onRowSelect(selectedRows)} // <-- callback to parent
            selectableRowsHighlight
        />
    );
};